import { useEffect, useState } from 'react';
import { Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import throttle from 'lodash.throttle';
import cn from 'classnames';

import Routes, { getSubRoutes } from '../../components/Routes';
import useResponsive from '../../hooks/useResponsive';
import GuideSynopsis from '../../components/GuideSynopsis/GuideSynopsis';
import { HeadWrapper } from '../../elements';
import NotFound from '../notfound/NotFound';
import { getMetadata } from './docsHelper'
import CombinedDocsMenu from './CombinedDocsMenu';
import CombinedDocsNavigation from './CombinedDocsNavigation/CombinedDocsNavigation';
import FintoLink from './FintoLink/FintoLink';
import docs from './CombinedDocs.module.scss';

const mapStateToProps = (state) => {
  return {
    authenticate: state.auth.authenticate,
    isSwitcherOpen: state.switcher.isSwitcherOpen,
    profile: state.auth.profile,
    apiVersions: state.swaggerApi.versions,
    selectedVersion: state.swaggerApi.selectedVersion
  };
};

const mapDispatchToProps = {};

const CombinedDocs = (props) => {
  const { authenticate, location, isSwitcherOpen, history, profile, apiVersions, selectedVersion } = props;
  const { isMobile } = useResponsive();

  const topNavHeight = 40;
  const fintoLinkHeight = 57;
  const headerHeight = profile ? 68 : 64;
  const [headerHeightOffset, setHeaderHeightOffset] = useState(headerHeight);
  const pathName = location.pathname;

  const isGuidePage = pathName.indexOf('/guide') != -1;
  const isApis = pathName.indexOf('/apis') != -1;
  const isSdks = pathName.indexOf('/sdks') != -1;

  const checkScrollTop = () => {
    if (window.scrollY < headerHeight) {
      setHeaderHeightOffset(headerHeightOffset - window.scrollY);
    }

    if (window.scrollY > headerHeight && headerHeightOffset !== 0) {
      setHeaderHeightOffset(0);
    }
  };

  const throttledFunc = throttle(checkScrollTop, 100, { leading: true });

  useEffect(() => {
    window.addEventListener('scroll', throttledFunc, false);
    return () => {
      window.removeEventListener('scroll', throttledFunc);
    };
  }, []);

  if (history.location.state && history.location.state.detail === 'wrong url request') {
    return <NotFound />;
  }

  return (
    <>
      <HeadWrapper
        href={`https://developer.staq.io${pathName}`}
        {...getMetadata(pathName)}
      />
      <CombinedDocsNavigation
        isSwitcherOpen={isSwitcherOpen}
        location={location}
        selectedVersion={selectedVersion}
        apiVersions={apiVersions}
      />
      <div className={docs.docs}>
        <div className={docs.docs__menu_wrapper}>
          <div
            className={cn(docs.docs__menu)}
            style={{
              height:
                !isMobile &&
                `calc(100vh - ${topNavHeight}px - ${headerHeightOffset}px - ${fintoLinkHeight}px)`,
            }}
            id="menu-section"
          >
            <CombinedDocsMenu routeProps={props} />
          </div>
          <FintoLink />
        </div>
        <div
          className={docs.docs__container}
          style={{
            transform: isMobile && 'none',
          }}
        >
          <div className={docs.docs__wrap}>
            <div className={cn(docs.docs__content, 'js-docs-box')}>
              {/* need to rerender the page when the api version changes so that the links work correctly in Synopsis column */}
              <div key={selectedVersion} className={docs.docs__hold_mobile}>
                {isGuidePage && (
                  <Switch>
                    {getSubRoutes(Routes.routes.FINTODOCS.routes.GUIDE, authenticate)}
                  </Switch>
                )}
                {isApis && (
                  <Switch>{getSubRoutes(Routes.routes.FINTODOCS.routes.APIS, authenticate)}</Switch>
                )}
                {isSdks && (
                  <Switch>{getSubRoutes(Routes.routes.FINTODOCS.routes.SDKS, authenticate)}</Switch>
                )}
              </div>
            </div>
          </div>
        </div>
        <div key={selectedVersion} className={docs.docs__guide}>
          <GuideSynopsis />
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CombinedDocs);
